import React from 'react';
import styled from 'styled-components';
import { SearchBar } from '../../atoms/SearchBar';
import { Button } from '../../atoms/Button';

interface SearchFormProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  onCreateClick: () => void;
  createButtonText?: string;
  searchPlaceholder?: string;
  className?: string;
  showSearch?: boolean;
  isCreateButtonDisabled?: boolean;
}

export const SearchForm: React.FC<SearchFormProps> = ({
  searchValue = "",
  onSearchChange = () => { },
  onCreateClick,
  createButtonText = 'Create',
  searchPlaceholder = 'Search',
  className,
  showSearch = true,
  isCreateButtonDisabled = false,
}) => {
  return (
    <SearchFormContainer className={className}>
      {showSearch && (
        <SearchSection>
          <SearchBar
            searchValue={searchValue}
            onSearchChange={onSearchChange}
            placeholder={searchPlaceholder}
          />
        </SearchSection>
      )}
      <ButtonSection>
        <Button
          text={createButtonText}
          variant="filled"
          onClick={onCreateClick}
          disabled={isCreateButtonDisabled}
        />
      </ButtonSection>
    </SearchFormContainer>
  );
};

const SearchFormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  /* Responsive design */
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  @media (max-width: 480px) {
    gap: 12px;
    margin-bottom: 16px;
  }
`;

const SearchSection = styled.div`
  flex: 1;
  min-width: 0; /* Prevents flex item from overflowing */

  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
  }
`;

const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0; /* Prevents button from shrinking */
  margin-left: auto;

  @media (max-width: 768px) {
    width: auto;
    justify-content: flex-end;
    margin-left: auto;
  }
`;
